import { LoginAdminDto } from '@routellers/types/dist/admin/login-admin.dto';
import { SuccessRO } from '@routellers/types/dist/shared/success.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = {
    data: LoginAdminDto;
};

type ResponseData = SuccessRO;

export const login: ApiMethodDeclaration<ParamsData, ResponseData> = ({ data }) => ({
    url: '/admins/login',
    method: 'POST',
    data,
});
